// extracted by mini-css-extract-plugin
module.exports = {"top":"ModuleSpacing_top__cPvRT","left":"ModuleSpacing_left__19US_","right":"ModuleSpacing_right__V87fW","bottom":"ModuleSpacing_bottom__-Lx8j"};